import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../ui/DataSelect";
import useQuestionForm from "./useQuestionForm";
import Checkbox from "../../../../../../../ui/Checkbox";



const styles = () => ({
    root: {
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        }
    },
});

const AddQuestionForm = ({ disabled, onFormChange, initialData, classes }) => {
    const [data, setData] = React.useState(initialData);
    const {
        dataSources,
        getTemplateList
    } = useQuestionForm();

    useEffect(() => {
        getTemplateList();
    }, []);

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
      data &&
        <div className={classes.root}>
            <TextField
                required
                value={data.question || ''}
                onChange={e => onChange("question", e.target.value)}
                label="Вопрос"
                disabled={disabled}
            />
            <Grid container spacing={2}>
                <Grid item xs={3}>
                  <TextField
                      required
                      value={data.order || 0}
                      onChange={e => onChange("order", e.target.value)}
                      label="Номер п/п"
                      disabled={disabled}
                  />
                </Grid>
                <Grid item xs={9}>
                    <DataSelect
                        required
                        value={data.typeId}
                        onChange={value => onChange("typeId", value._key)}
                        label="Шаблон"
                        keyField="_key"
                        dataSource={dataSources.templates}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
          <Checkbox checked={data.isRequired}
                    handleChange={() => onChange("isRequired", !data.isRequired)}
                    label="Обязательный для ответа"
                    disabled={disabled}/>
        </div>
    );
};

export default withStyles(styles)(AddQuestionForm);
